/* Outfit: obliga a elegir talla y color antes de comprar (no cambia la variante real, solo la apariencia y el bloqueo de los botones de compra). Solo actua sobre el selector del producto principal. Tambien rotula el boton de pago alterno, evita que la pagina suba sola al elegir talla/color, oculta las pestanas vacias y sugiere el cinturon que hace juego (lo agrega junto con el calzado elegido y lo lleva al pago por Addi/PSE/tarjeta). */
(function () {
  if (window.__outfitReqOpt) return;
  window.__outfitReqOpt = true;
  var chosen = {};
  var lastPick = 0;
  var BUY = '#rsi_buy_now_button, .product-form__submit, .shopify-payment-button__button, .shopify-payment-button button';
  var GROUP = '.globo-swatch-product-detail .swatch--gl';
  var PAY_TEXT = '💳 Pagar con Addi, Sistecrédito, PSE o tarjeta';
  var HIDE_IF_EMPTY = /^(caracter[ií]sticas|detalles|¿?c[oó]mo cuidarlos\??)$/i;
  var BELT = 'cinturon-outfit-para-caballero';
  var SKIP_BELT = [BELT, 'pantalon-en-dril-licrado'];
  var beltData = null;
  var beltPromise = null;
  var addedBelt = null;
  var addedShoe = null;

  /* El tema sube la pagina a la galeria cuando cambia la foto de la variante; lo ignoramos justo despues de elegir una opcion. */
  var origScrollTo = window.scrollTo;
  window.scrollTo = function () {
    if (Date.now() - lastPick < 2500) return;
    return origScrollTo.apply(window, arguments);
  };

  /* Oculta las pestanas desplegables que no tienen texto. Vuelven solas cuando el producto tenga contenido. */
  function hideEmptyTabs() {
    var tabs = document.querySelectorAll('.product__accordion');
    for (var i = 0; i < tabs.length; i++) {
      var t = tabs[i];
      var s = t.querySelector('summary');
      var c = t.querySelector('.accordion__content');
      if (!s || !c) continue;
      var name = s.textContent.replace(/\s+/g, ' ').trim();
      if (!HIDE_IF_EMPTY.test(name)) continue;
      var empty = c.textContent.replace(/\s+/g, '').length === 0 && !c.querySelector('img, video, iframe');
      if (empty && t.style.display !== 'none') t.style.display = 'none';
      else if (!empty && t.style.display === 'none') t.style.display = '';
    }
  }

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function loadBelt() {
    if (!beltPromise) {
      beltPromise = fetch('/products/' + BELT + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { beltData = p; return p; })
        .catch(function () { return null; });
    }
    return beltPromise;
  }

  /* Color elegido + material (gamuza/charol/brillante) -> variante del cinturon. */
  function beltKey(colorTxt, titleTxt) {
    var c = norm(colorTxt);
    var all = norm(titleTxt) + ' ' + c;
    var mat = all.indexOf('gamuza') > -1 ? 'gamuza' : all.indexOf('charol') > -1 ? 'charol' : 'brillante';
    if (/blanco/.test(c)) return 'blanco-charol';
    if (/miel|conac/.test(c)) return mat === 'gamuza' ? 'miel-gamuza' : 'miel-brillante';
    if (/negro/.test(c)) return mat === 'gamuza' ? 'negro-gamuza' : mat === 'charol' ? 'negro-charol' : 'negro-brillante';
    if (/cafe|marron/.test(c)) return mat === 'gamuza' ? 'cafe-gamuza' : 'cafe-brillante';
    return null;
  }

  function selectedColor() {
    var gs = groups().filter(function (g) { return key(g) === '0' && g.offsetParent !== null; });
    var g = gs[0] || groups().filter(function (x) { return key(x) === '0'; })[0];
    if (!g) return '';
    var inp = g.querySelector('input:checked');
    if (!inp) return '';
    var lab = inp.id ? g.querySelector('label[for="' + inp.id + '"]') : null;
    return (inp.value || '') + ' ' + ((lab && (lab.getAttribute('title') || lab.getAttribute('data-title'))) || '');
  }

  function beltBox() {
    var b = document.getElementById('outfit-belt-pdp');
    if (b) return b;
    var btns = document.querySelector('.product-form__buttons');
    if (!btns || !btns.parentNode) return null;
    b = document.createElement('div');
    b.id = 'outfit-belt-pdp';
    b.style.cssText = 'display:none;margin:1rem 0;padding:1rem 1.2rem;border:1px solid #e3e3e3;border-radius:10px;background:#fff';
    btns.parentNode.insertBefore(b, btns.nextSibling);
    return b;
  }

  function refreshBubble(sections) {
    try {
      var bub = document.getElementById('cart-icon-bubble');
      if (bub && sections && sections['cart-icon-bubble']) {
        var sec = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (sec) bub.innerHTML = sec.innerHTML;
      }
    } catch (err) {}
  }

  /* Si el cliente cambia color o talla despues de agregar, quitamos lo que agregamos nosotros para que el pedido no quede con una talla vieja. */
  function undoAdded() {
    if (!addedBelt && !addedShoe) return Promise.resolve();
    var ups = {};
    if (addedBelt) ups[addedBelt] = 0;
    if (addedShoe) ups[addedShoe] = 0;
    addedBelt = null;
    addedShoe = null;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: ups, sections: 'cart-icon-bubble', sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) { refreshBubble(d && d.sections); })
      .catch(function () {});
  }

  function updateBelt() {
    if (SKIP_BELT.some(function (h) { return location.pathname.indexOf('/products/' + h) > -1; })) return;
    if (!chosen['0']) return;
    var box = beltBox();
    if (!box) return;
    var titleEl = document.querySelector('.product__title');
    var k = beltKey(selectedColor(), titleEl ? titleEl.textContent : '');
    if (!k) { box.style.display = 'none'; return; }
    loadBelt().then(function (p) {
      if (!p) return;
      var v = p.variants.filter(function (x) { return norm(x.title) === k && x.available; })[0];
      if (!v) { box.style.display = 'none'; return; }
      var done = addedBelt === v.id ? '1' : '0';
      if (box.getAttribute('data-k') === k && box.getAttribute('data-done') === done) { box.style.display = 'block'; return; }
      var src = (v.featured_image && v.featured_image.src) || p.featured_image || '';
      var img = src ? '<img src="' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" style="width:56px;height:56px;object-fit:cover;border-radius:6px;background:#f3f3f3">' : '';
      var price = '$' + Math.round(v.price / 100).toLocaleString('es-CO');
      box.setAttribute('data-k', k);
      box.setAttribute('data-done', done);
      box.innerHTML = '<p style="font-size:1.4rem;font-weight:700;margin:0 0 .8rem">Hace juego con tu pedido</p><div style="display:flex;align-items:center;gap:1rem">' + img + '<div style="flex:1;font-size:1.3rem;line-height:1.3"><b style="display:block;text-transform:capitalize">Cinturón ' + v.title.replace(/-/g, ' ') + '</b>' + price + '</div>' + (done === '1' ? '<span style="font-size:1.3rem;font-weight:700;color:#1a7f37">✔ Agregado</span>' : '<button type="button" data-outfit-belt-pdp="' + v.id + '" style="background:#66280a;color:#fff;border:0;border-radius:6px;padding:.8rem 1.2rem;font-size:1.3rem;font-weight:600;cursor:pointer">Agregar al pedido</button>') + '</div>' + (done === '1' ? '<p style="font-size:1.2rem;margin:.8rem 0 0;color:#444">Tu calzado y el cinturón ya están en tu pedido. Elige cómo pagar: «Paga en casa» o el botón de Addi, PSE y tarjeta.</p>' : '');
      box.style.display = 'block';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-outfit-belt-pdp]');
    if (!btn) return;
    e.preventDefault();
    var id = Number(btn.getAttribute('data-outfit-belt-pdp'));
    var form = document.querySelector('form[action*="/cart/add"]');
    var idInp = form && form.querySelector('input[name="id"]');
    var qtyInp = form && form.querySelector('input[name="quantity"]');
    var shoeId = idInp ? Number(idInp.value) : 0;
    var qty = qtyInp ? Math.max(1, Number(qtyInp.value) || 1) : 1;
    btn.disabled = true;
    btn.textContent = 'Agregando…';
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var shoeInCart = cart.items.some(function (it) { return it.variant_id === shoeId; });
        var items = [];
        if (shoeId && !shoeInCart) items.push({ id: shoeId, quantity: qty });
        items.push({ id: id, quantity: 1 });
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items, sections: 'cart-icon-bubble', sections_url: location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (!data || data.status) throw new Error('add');
            addedBelt = id;
            addedShoe = shoeId && !shoeInCart ? shoeId : null;
            refreshBubble(data.sections);
            var box = document.getElementById('outfit-belt-pdp');
            if (box) box.removeAttribute('data-k');
            updateBelt();
          });
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Agregar al pedido'; });
  }, true);

  function relabel() {
    var btns = document.querySelectorAll('.product-form__buttons .shopify-payment-button__button--unbranded');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].textContent.trim() !== PAY_TEXT) btns[i].textContent = PAY_TEXT;
    }
  }

  function groups() {
    return Array.prototype.slice.call(document.querySelectorAll(GROUP));
  }

  function key(g) {
    return g.getAttribute('data-option-index');
  }

  function sync() {
    groups().forEach(function (g) {
      var has = !!chosen[key(g)];
      if (g.classList.contains('outfit-chosen') !== has) g.classList.toggle('outfit-chosen', has);
    });
  }

  /* Una opcion pendiente por indice (la app puede dibujar copias ocultas del selector). */
  function pending() {
    var seen = {};
    groups().forEach(function (g) {
      var k = key(g);
      if (chosen[k]) return;
      var vis = g.offsetParent !== null;
      if (!seen[k] || (vis && !seen[k].vis)) seen[k] = { g: g, vis: vis };
    });
    return Object.keys(seen)
      .sort()
      .map(function (k) {
        return seen[k].g;
      });
  }

  function msgText(p) {
    var names = p.map(function (g) {
      var l = g.querySelector('legend');
      return ((l && l.getAttribute('data-name')) || 'una opción').toLowerCase();
    });
    return 'Por favor elige ' + names.join(' y ') + ' para continuar.';
  }

  function msgEl() {
    var m = document.getElementById('outfit-opt-msg');
    if (!m) {
      var first = pending()[0] || groups()[0];
      if (!first) return null;
      var host = first.closest('.globo-swatch-list') || first.parentNode;
      if (!host || !host.parentNode) return null;
      m = document.createElement('div');
      m.id = 'outfit-opt-msg';
      m.setAttribute('role', 'alert');
      host.parentNode.insertBefore(m, host);
    }
    return m;
  }

  function markChosen(e) {
    var li = e.target && e.target.closest && e.target.closest(GROUP + ' li');
    if (!li) return;
    lastPick = Date.now();
    var g = li.closest('.swatch--gl');
    chosen[key(g)] = true;
    sync();
    var m = document.getElementById('outfit-opt-msg');
    if (m && m.classList.contains('is-on')) {
      var p = pending();
      if (p.length) m.textContent = msgText(p);
      else m.classList.remove('is-on');
    }
    if (addedBelt || addedShoe) {
      undoAdded().then(function () { setTimeout(updateBelt, 350); });
    } else if (key(g) === '0') {
      setTimeout(updateBelt, 350);
    }
  }

  function block(e) {
    var p = pending();
    if (!p.length) return false;
    e.preventDefault();
    e.stopImmediatePropagation();
    var m = msgEl();
    if (m) {
      m.textContent = msgText(p);
      m.classList.add('is-on');
    }
    var target = p.filter(function (g) {
      return g.offsetParent !== null;
    })[0];
    if (target) target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    p.forEach(function (g) {
      g.classList.remove('outfit-shake');
      void g.offsetWidth;
      g.classList.add('outfit-shake');
    });
    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      var b = e.target && e.target.closest && e.target.closest(BUY);
      if (b && block(e)) return;
      /* El boton de Addi/PSE/tarjeta compra solo el producto de la pagina; si agregamos el cinturon, vamos al pago con el carrito completo. */
      if (b && addedBelt && b.closest('.shopify-payment-button')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = '/checkout';
        return;
      }
      markChosen(e);
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      if (e.isTrusted && e.target && e.target.closest && e.target.closest(GROUP)) markChosen(e);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (f && f.matches && f.matches('form[action*="/cart/add"]')) block(e);
    },
    true
  );

  new MutationObserver(function () {
    sync();
    relabel();
    hideEmptyTabs();
  }).observe(document.documentElement, { childList: true, subtree: true });
  sync();
  relabel();
  hideEmptyTabs();
})();
